<span class="beta-label" [ngClass]="{ absolute: !isStatic }" [matTooltip]="'general.beta_info' | translate">BETA</span>
